import { render, staticRenderFns } from "./customGoods.edit.vue?vue&type=template&id=1ee1e80c&scoped=true"
import script from "./customGoods.edit.vue?vue&type=script&lang=js"
export * from "./customGoods.edit.vue?vue&type=script&lang=js"
import style0 from "./customGoods.edit.vue?vue&type=style&index=0&id=1ee1e80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee1e80c",
  null
  
)

export default component.exports